// extracted by mini-css-extract-plugin
module.exports = {"message":"_519e26f0","confirm":"_46004c09 _519e26f0","ctaFull":"_72db71be"};